import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationInfoBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 164px;
  padding: ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.Grey100};
`

export const DetailsWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`
